import { toast } from 'vue3-toastify';

import { useDefaultRecordsPerPage } from '@/composables/useDefaultRecordsPerPage';
import type {
  IAdditionalSettings,
  IAdditionalSettingsPayload
} from '@/interfaces/agency/settings/agency/additional-settings';
import additionalSettingsServices from '@/services/agency/settings/agency/additional-settings';

const { AGENCY_ADDITIONAL_SETTINGS_KEY } = useDefaultRecordsPerPage();

export const useAdditionalSettingsStore = defineStore('additionalSettingsStore', {
  state: () => ({
    additionalSettings: [] as IAdditionalSettings[]
  }),

  getters: {
    getAdditionalSettings: state => state.additionalSettings
  },

  actions: {
    async fetchAdditionalSettings() {
      const { data } = await additionalSettingsServices.fetchAdditionalDetails();

      this.additionalSettings = data;
      localStorage.setItem(AGENCY_ADDITIONAL_SETTINGS_KEY, JSON.stringify(data));
    },

    async updateAdditionalSettings(id: number, payload: IAdditionalSettingsPayload, label = 'Additional') {
      await additionalSettingsServices.updateAdditionalDetails(id, payload);

      toast.success(`${label} setting updated successfully!`);
      await this.fetchAdditionalSettings();
    }
  }
});
